export const getBrowserLanguage = () => {
  const browserLanguage = navigator.language;
  switch (browserLanguage) {
    case "en-US":
      return "en";
    case "vi":
      return "vi";

    default:
      return "en";
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export function scrollToElement(selector: string, isCenter?: boolean) {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
      block: isCenter? "center":"start",
      inline: "nearest",
    });
  } else {
    console.error(`Element with selector "${selector}" not found.`);
  }
}
